import { createFileRoute } from '@tanstack/react-router';

import { useTelegramBackButton } from '@common/hooks';
import { Page } from '@common/ui/Page';

import { FriendSetup } from '@widgets/matchmaker/FriendSetup';

export const Route = createFileRoute('/matchmaker/friend')({
  component: Component,
});

export default function Component() {
  useTelegramBackButton({ to: 'back' });

  return (
    <Page>
      <FriendSetup />
    </Page>
  );
}
